import { createContext, useState, useEffect } from "react";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    const savedCart = localStorage.getItem("cart");
    return savedCart ? JSON.parse(savedCart) : [];
  });

  const [billing, setBilling] = useState(() => {
    const savedBilling = localStorage.getItem("billing");
    return savedBilling ? JSON.parse(savedBilling) : { total: 0 };
  });

  const [customer, setCustomer] = useState({
    firstName: "",
    lastName: "",
    address: "",
    phone1: "",
    phone2: "",
    email: "",
  });

  // Calculate total price from cart
  const calculateTotal = (cart) => {
    return cart.reduce((acc, item) => acc + item.price * item.quantity, 0);
  };

  // Save cart and billing to localStorage when they change
  useEffect(() => {
    localStorage.setItem("cart", JSON.stringify(cart));
    localStorage.setItem("billing", JSON.stringify(billing));
  }, [cart, billing]);

  // Add item to cart
  const addToCart = (product) => {
    setCart((prevCart) => {
      const existingItem = prevCart.find((item) => item.id === product.id);
      let updatedCart;

      if (existingItem) {
        updatedCart = prevCart.map((item) =>
          item.id === product.id ? { ...item, quantity: item.quantity + 1 } : item
        );
      } else {
        updatedCart = [...prevCart, { ...product, quantity: 1 }];
      }

      setBilling({ total: calculateTotal(updatedCart) });
      return updatedCart;
    });
  };

  const clearCart = () => {
    setCart([]);
  };
  

  // Remove item from cart
  const removeFromCart = (productId) => {
    setCart((prevCart) => {
      const updatedCart = prevCart.filter((item) => item.id !== productId);
      setBilling({ total: calculateTotal(updatedCart) });
      return updatedCart;
    });
  };

  // Update item quantity
  const updateQuantity = (productId, newQuantity) => {
    setCart((prevCart) => {
      const updatedCart = prevCart.map((item) =>
        item.id === productId ? { ...item, quantity: newQuantity } : item
      );
      setBilling({ total: calculateTotal(updatedCart) });
      return updatedCart;
    });
  };

  // Update customer details (not saved to localStorage)
  const updateCustomer = (details) => {
    setCustomer((prev) => ({ ...prev, ...details }));
  };

  const getTotalCartCount = () => {
    return cart.reduce((total, item) => total + (item.quantity || 1), 0);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        clearCart,
        addToCart,
        removeFromCart,
        updateQuantity,
        billing,
        customer,
        updateCustomer,
        getTotalCartCount
      }}
    >
      {children}
    </CartContext.Provider>
  );
};
